import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import btu_logo from '@/assets/images/logo.svg';

import { getUrls } from '@/utils/urls/getUrls';

import MainMenu from '@/views/components/Header/MainMenu/MainMenu';

import styles from '@/views/components/Header/Header.module.scss';

const Header = ({ narrow, noLoggedInLinks = false }) => {
	const { dict } = useSelector((state) => state.app);
	const { letters } = getUrls();

	return (
		<header className={ `${ styles['header'] } ${narrow ? styles['narrow'] : ''}` }>
			<Link to={ letters } >
				<img
					src={ btu_logo }
					alt={ dict.header.logoAlt }
					className={ styles['header-logo'] }
				/>
			</Link>
			{ !noLoggedInLinks && <MainMenu /> }
		</header>
	);
};

Header.propTypes = {
	narrow: PropTypes.bool,
};

export default Header;
